import React from 'react';

export const PermissionDenied = (props) => {
  return (
    <div className="mt-5 d-flex flex-column justify-content-center text-center">
      <i className="r-heading-1 fi flaticon-alert r-text--brandF"/>
      <p className="r-heading-3">You don't have permissions to access this page!</p>
    </div>
  )
}